module.exports = __webpack_public_path__ + "img/my_battle.674c0726.png";